export const LANG_ES_DICTIONARY = {
  LANG_EN: 'Inglés',
  LANG_ES: 'Español',
  LANG_PT: 'Portugués',
} as const;
